import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.25 3.573c0-.178.145-.323.323-.323h4.83c.179 0 .323.145.323.323v2.202H7.598a1.823 1.823 0 0 0-1.823 1.823v1.128H3.573a.323.323 0 0 1-.323-.323zm2.525 6.653H3.573A1.823 1.823 0 0 1 1.75 8.403v-4.83c0-1.007.816-1.823 1.823-1.823h4.83c1.007 0 1.823.816 1.823 1.823v2.202h2.202c1.007 0 1.823.816 1.823 1.823v4.83a1.823 1.823 0 0 1-1.823 1.823h-4.83a1.823 1.823 0 0 1-1.823-1.823z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }